import {uiPartCreateNamespacedParts} from "@wix/devzai-utils-common";

export const DoppeActionLockPreviewParts = uiPartCreateNamespacedParts('DoppeActionLockPreviewParts', {
    UnlockButton: 'UnlockButton'
})